import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth";
import socket from "./socket";
import domain from "./domain";
import computer from "./computer";
import computerPackage from "./computerPackage";
import groupPackage from "./groupPackage";
import group from "./group";
import source from "./source";
import powershell from "./powershell";
import infobar from "./infobar";
import settings from "./settings";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules: {
    infobar,
    settings,
    powershell,
    group,
    socket,
    auth,
    domain,
    computer,
    computerPackage,
    groupPackage,
    source,
  },
});
